import { instance } from "api/apiBase";
import {
  BoomFinanceLender,
  BoomFinanceMagicLinkResponse,
  BoomFinanceStatusResponse
} from "api/boom-finance/types";

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/boom_finance";

export const boomFinanceApi = {
  connect: async (): Promise<BoomFinanceStatusResponse> => {
    const { data } =
      await instance.post<BoomFinanceStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  // Implement in BoomFinance API
  disconnect: async (): Promise<BoomFinanceStatusResponse> => {
    const { data } =
      await instance.delete<BoomFinanceStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  getLenders: async (): Promise<BoomFinanceLender[]> => {
    const { data } = await instance.get<{ data: BoomFinanceLender[] }>(
      `${BASE_ENDPOINT_URL}/lenders`
    );
    return data.data;
  },

  setLenderEnablement: async ({
    lenderId,
    enabled
  }: {
    lenderId: string;
    enabled: boolean;
  }): Promise<BoomFinanceLender> => {
    const { data } = await instance.patch<BoomFinanceLender>(
      `${BASE_ENDPOINT_URL}/lenders/${lenderId}/enablement`,
      { enabled }
    );
    return data;
  },

  // Mint a partner magic link. Pass `redirectTo` to land the user on a specific
  // path after sign-in — the returned URL carries it as a `?to=` query param
  // (e.g. `/applications/<boom_finance_external_id>`), so callers open the URL
  // as-is rather than appending to it.
  createMagicLink: async (params?: {
    redirectTo?: string;
  }): Promise<BoomFinanceMagicLinkResponse> => {
    const { data } = await instance.post<BoomFinanceMagicLinkResponse>(
      `${BASE_ENDPOINT_URL}/magic_link`,
      params?.redirectTo ? { redirect_to: params.redirectTo } : undefined
    );
    return data;
  }
};
